module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "break"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc_head"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "bigspace"
  }), _c('p', {
    staticClass: "tocitem"
  }, [_c('a', {
    attrs: {
      "href": "#/html/06_acknowledgments"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "xsmallspace"
  }), _c('p', {
    staticClass: "tocitem"
  }, [_c('a', {
    attrs: {
      "href": "#/html/07_foreword"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _c('p', {
    staticClass: "tocitem"
  }, [_c('a', {
    attrs: {
      "href": "#/html/08_intro"
    }
  }, [_vm._v("Introduction: "), _c('span', {
    staticClass: "small1"
  }, [_c('i', [_vm._v("The Need for Foundations")])])])]), _vm._v(" "), _c('p', {
    staticClass: "xsmallspace"
  }), _c('p', {
    staticClass: "tocitem1"
  }, [_vm._v("An Education in Freedom—The Specific Mission of a Catholic School—The Heart of the Book")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    staticClass: "small1",
    staticStyle: {
      "margin-right": "1em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_chap1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I.")])]), _c('span', {
    attrs: {
      "href": "#/html/09_chap1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Child, Person, Teacher: "), _c('span', {
    staticClass: "small1"
  }, [_c('i', [_vm._v("At the Heart of a Catholic School")])])])]), _vm._v(" "), _c('p', {
    staticClass: "xsmallspace"
  }), _c('p', {
    staticClass: "tocitem1"
  }, [_vm._v("Revival of the Trivium—Centering Education on the Child—To Be a Child—Attention—A Catholic Philosophy of Education")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    staticClass: "small1",
    staticStyle: {
      "margin-right": ".75em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II.")])]), _c('span', {
    attrs: {
      "href": "#/html/10_chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Remembering: "), _c('span', {
    staticClass: "small1"
  }, [_c('i', [_vm._v("Grammar–Mythos–Imagining the Real")])])])]), _vm._v(" "), _c('p', {
    staticClass: "xsmallspace"
  }), _c('p', {
    staticClass: "tocitem1"
  }, [_vm._v("Naming: The First Human Task—Man the Mediator—Recollecting and the Spirit of Tradition—Anti-Tradition and "), _c('i', [_vm._v("Anamnesis")]), _vm._v("—Defending the Art of Memory—The Hall of Fire—Music of Creation")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    staticClass: "small1",
    staticStyle: {
      "margin-right": ".45em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III.")])]), _c('span', {
    attrs: {
      "href": "#/html/11_chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dialectic: "), _c('span', {
    staticClass: "small1"
  }, [_c('i', [_vm._v("Thinking–Logos–Knowing the Real")])])])]), _vm._v(" "), _c('p', {
    staticClass: "xsmallspace"
  }), _c('p', {
    staticClass: "tocitem1"
  }, [_vm._v("An Honorable Art—Encouraging Thought—Dialectics for Children—The Search for Truth—Faith and Reason—In Search of Foundations—Evolution—Dialectic")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    staticClass: "small1",
    staticStyle: {
      "margin-right": ".45em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV.")])]), _c('span', {
    attrs: {
      "href": "#/html/12_chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Speaking: "), _c('span', {
    staticClass: "small1"
  }, [_c('i', [_vm._v("Rhetoric–Ethos–Community in the Real")])])])]), _vm._v(" "), _c('p', {
    staticClass: "xsmallspace"
  }), _c('p', {
    staticClass: "tocitem1"
  }, [_vm._v("Word of God, Breath of God—Ethos—Who Am I, Again?—Recovery of Freedom—Poetic Form—The Liturgical Heart")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    staticClass: "small1",
    staticStyle: {
      "margin-right": ".8em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V.")])]), _c('span', {
    attrs: {
      "href": "#/html/13_chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wisdom: "), _c('span', {
    staticClass: "small1"
  }, [_c('i', [_vm._v("Beyond the Liberal Arts")])])])]), _vm._v(" "), _c('p', {
    staticClass: "xsmallspace"
  }), _c('p', {
    staticClass: "tocitem1"
  }, [_vm._v("The Other Arts—History—Dreaming a Catholic School")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    staticClass: "small1",
    staticStyle: {
      "margin-right": ".4em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI.")])]), _c('span', {
    attrs: {
      "href": "#/html/14_chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Learning in Love: "), _c('span', {
    staticClass: "small1"
  }, [_c('i', [_vm._v("Parents as Educators")])])])]), _vm._v(" "), _c('p', {
    staticClass: "xsmallspace"
  }), _c('p', {
    staticClass: "tocitem1"
  }, [_vm._v("Cultivating the Moral Imagination—Education of the Heart—Charlotte Mason—John Holt—The Holy Family")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/15_conclusion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: "), _c('span', {
    staticClass: "small1"
  }, [_c('i', [_vm._v("Beauty in the Word")])])])]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/16_coda",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Coda")])]), _vm._v(" "), _c('p', {
    staticClass: "xsmallspace"
  }), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/17_endnotes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Endnotes")])]), _vm._v(" "), _c('p', {
    staticClass: "xsmallspace"
  }), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/18_bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "xsmallspace"
  }), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/19_index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index of Names")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71a20abc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/05_contents.vue
// module id = 69
// module chunks = 0